import { Flex, Typography } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

export const CommentarySection = ({
  id,
  title,
  subtitle,
  children,
}: PropsWithChildren<{ id: string; title: string; subtitle?: string }>) => (
  <Flex flexDirection="column" gap={6}>
    <Flex flexDirection="column" gap={3} maxWidth="960px">
      <Typography variant="h1" id={id}>
        {title}
      </Typography>
      {subtitle && <Typography variant="body1">{subtitle}</Typography>}
    </Flex>

    {children}
  </Flex>
);
